module.exports = __webpack_public_path__ + "static/app-shot-1-1-08661fc07b2c7592f6f3c1a866db9641.jpg";